import React from 'react';
import { Form, Input, Select } from 'antd';
import { BulkWearableItem } from './types';

const { Option } = Select;
const { TextArea } = Input;

interface BulkWearableDetailsProps {
  styles: { [key: string]: string };
  bulkItems: BulkWearableItem[];
}

const BulkWearableDetails: React.FC<BulkWearableDetailsProps> = ({ styles, bulkItems }) => (
  <div className={styles.stepContainer}>
    <h2 className={styles.stepTitle}>Basic Details</h2>

    {bulkItems.length === 0 && (
      <p style={{ color: '#888' }}>No items parsed from the uploaded file.</p>
    )}

    {bulkItems.map((item, index) => (
      <div key={`${item.itemId}-${index}`} className={styles.bulkItemCard}>
        <div className={styles.wearableBasicsWrapper}>
          <div className={styles.wearableThumbnailPreview}>
            {item.image ? (
              <img
                src={item.image}
                alt={item.itemName}
                className={styles.wearablePreviewImage}
              />
            ) : (
              <div className={styles.wearableNoImage}>
                <p>No image selected</p>
              </div>
            )}
            {item.itemName && (
              <p className={styles.fileName}>{item.itemName}</p>
            )}
          </div>

          <div className={styles.wearableFormGrid}>
            <div className={styles.wearableFormColumn}>
              <Form.Item
                label="Wearable Type"
                name={['bulkItems', index, 'wearableType']}
                className={styles.formItem}
              >
                <Select placeholder="Select Type" className={styles.selectInput}>
                  <Option value="top">Top</Option>
                  <Option value="bottom">Bottom</Option>
                  <Option value="accessory">Accessory</Option>
                  <Option value="footwear">Footwear</Option>
                  <Option value="outerwear">Outerwear</Option>
                </Select>
              </Form.Item>

              <Form.Item
                label="Style"
                name={['bulkItems', index, 'style']}
                className={styles.formItem}
              >
                <Select placeholder="Select Style" className={styles.selectInput}>
                  <Option value="formal">Formal</Option>
                  <Option value="casual">Casual</Option>
                  <Option value="sporty">Sporty</Option>
                  <Option value="elegant">Elegant</Option>
                  <Option value="minimalist">Minimalist</Option>
                </Select>
              </Form.Item>
            </div>

            <div className={styles.wearableFormColumn}>
              <Form.Item
                label="Material"
                name={['bulkItems', index, 'material']}
                className={styles.formItem}
              >
                <Select placeholder="Select Material" className={styles.selectInput}>
                  <Option value="NA">NA</Option>
                  <Option value="cotton">Cotton</Option>
                  <Option value="polyester">Polyester</Option>
                  <Option value="wool">Wool</Option>
                  <Option value="silk">Silk</Option>
                  <Option value="linen">Linen</Option>
                  <Option value="nylon">Nylon</Option>
                </Select>
              </Form.Item>

              <Form.Item
                label="Fabric"
                name={['bulkItems', index, 'fabric']}
                className={styles.formItem}
              >
                <Select placeholder="Select Fabric" className={styles.selectInput}>
                  <Option value="cotton">Cotton</Option>
                  <Option value="blend">Cotton Blend</Option>
                  <Option value="organic">Organic Cotton</Option>
                  <Option value="synthetic">Synthetic</Option>
                  <Option value="natural">Natural Fiber</Option>
                </Select>
              </Form.Item>
            </div>
          </div>
        </div>

        <div className={styles.wearableFullWidth}>
          <Form.Item
            label="Item Name"
            name={['bulkItems', index, 'itemName']}
            className={styles.formItem}
          >
            <Input placeholder="Enter Item Name" className={styles.textInput} />
          </Form.Item>

          <Form.Item
            label="Tags"
            name={['bulkItems', index, 'tags']}
            className={styles.formItem}
          >
            <Input placeholder="Enter Tags (comma-separated)" className={styles.textInput} />
          </Form.Item>
        </div>

        <Form.Item
          label="Description"
          name={['bulkItems', index, 'description']}
          className={styles.formItem}
        >
          <TextArea placeholder="Enter Description" className={styles.textareaInput} rows={6} />
        </Form.Item>
      </div>
    ))}
  </div>
);

export default BulkWearableDetails;
